<template>
  <v-card min-width="208px">
    <v-navigation-drawer permanent>
      <v-list dense nav>
        <v-list-item-group>
           
          <router-link to="/admin/dashboard">
            <v-list-item :class="checkUrl('dashboard') ? 'active' : ''">
              <v-img
                :src="checkUrl('dashboard') ? Investometer_active : Investometer"
                :lazy-src="checkUrl('dashboard') ? Investometer_active : Investometer"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Marketing Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/businessdashboard">
            <v-list-item :class="checkUrl('business-dashboard') ? 'active' : ''">
              <v-img
                :src="checkUrl('business-dashboard') ? Investometer_active : Investometer"
                :lazy-src="checkUrl('business-dashboard') ? Investometer_active : Investometer"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title> Business Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/CampaignTopic">
            <v-list-item :class="checkUrl('campaigntopic') ? 'active' : ''">
              <v-img
                :src="checkUrl('campaigntopic') ? Liabilities_active : Liabilities"
                :lazy-src="checkUrl('campaigntopic') ? Liabilities_active : Liabilities"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Campaign Topic</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/campaigns" >
            <v-list-item :class="checkUrl('campaigns') ? 'active' : ''">
              <v-img
                :src="checkUrl('campaigns') ? Investment_active : Investment"
                :lazy-src="checkUrl('campaigns') ? Investment_active : Investment"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Campaigns</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>          
          <router-link to="/admin/subscription" >
            <v-list-item :class="checkUrl('subscription') ? 'active' : ''">
              <v-img :src="checkUrl('subscription') ? Subscription_Active : Subscription" :lazy-src="checkUrl('subscription') ? Subscription_Active : Subscription">
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Subscription Plan</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/discount" >
            <v-list-item :class="checkUrl('discount') ? 'active' : ''">
              <v-img
                :src="checkUrl('discount') ? Investment_active : Investment"
                :lazy-src="checkUrl('discount') ? Investment_active : Investment"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Discount Rate</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
           <router-link to="/admin/ListWillCoupon" >
            <v-list-item :class="checkUrl('will-discount') ? 'active' : ''">
              <v-img
                :src="checkUrl('will-discount') ? Investment_active : Investment"
                :lazy-src="checkUrl('will-discount') ? Investment_active : Investment"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>WILL Coupon</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/settings" >
            <v-list-item :class="checkUrl('settings') ? 'active' : ''">
              <v-img
                :src="checkUrl('settings') ? Wills_active : Wills"
                :lazy-src="checkUrl('settings') ? Wills_active : Wills"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Trial Period</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
            <router-link to="/admin/most-visited-page" >
            <v-list-item :class="checkUrl('mostvisited') ? 'active' : ''">
              <v-img
                :src="checkUrl('mostvisited') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('mostvisited') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>Most Visited Page</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
           <router-link to="/admin/fintalkcategories" >
            <v-list-item :class="checkUrl('fintalkCategories') ? 'active' : ''">
              <v-img
                :src="checkUrl('fintalkCategories') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('fintalkCategories') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>FinTalk Category</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
           <router-link to="/admin/fintalks" >
            <v-list-item :class="checkUrl('fintalk') ? 'active' : ''">
              <v-img
                :src="checkUrl('fintalk') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('fintalk') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>FinTalk Articles</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/fintalk-disclaimer" >
            <v-list-item :class="checkUrl('disclaimer') ? 'active' : ''">
              <v-img
                :src="checkUrl('disclaimer') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('disclaimer') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>FinTalk Disclaimer</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
            <router-link to="/admin/finstatcategories" >
            <v-list-item :class="checkUrl('finstatCategories') ? 'active' : ''">
              <v-img
                :src="checkUrl('finstatCategories') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('finstatCategories') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>FinStat Category</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/finstat" >
            <v-list-item :class="checkUrl('finstat') ? 'active' : ''">
              <v-img
                :src="checkUrl('finstat') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('finstat') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>FinStat Articles</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <!-- <router-link to="/admin/finstat-disclaimer" >
            <v-list-item :class="checkUrl('disclaimer') ? 'active' : ''">
              <v-img
                :src="checkUrl('disclaimer') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('disclaimer') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>FinStat Disclaimer</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link> -->
           <!-- <router-link to="/admin/banks" >
            <v-list-item :class="checkUrl('banks') ? 'active' : ''">
              <v-img
                :src="checkUrl('campaigns') ? Investment_active : Investment"
                :lazy-src="checkUrl('campaigns') ? Investment_active : Investment"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Banks</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link> -->
           <!-- <router-link to="/admin/post-office" >
            <v-list-item :class="checkUrl('post-office') ? 'active' : ''">
              <v-img
                :src="checkUrl('campaigns') ? Investment_active : Investment"
                :lazy-src="checkUrl('campaigns') ? Investment_active : Investment"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Post Office</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link> -->
          <router-link to="/admin/AssignPromoCode" >
            <v-list-item :class="checkUrl('AssignPromoCode') ? 'active' : ''">
              <v-img
                :src="checkUrl('AssignPromoCode') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('AssignPromoCode') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>Referral</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/admin/MasterIndex" >
            <v-list-item :class="checkUrl('MasterIndex') ? 'active' : ''">
              <v-img
                :src="checkUrl('MasterIndex') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('MasterIndex') ? Accounts_active : Accounts"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>Master</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>     
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        Investometer_active:process.env.VUE_APP_ROOT_ICONS_URL + 'Investometer_active.png',
        Investometer:process.env.VUE_APP_ROOT_ICONS_URL + 'Investometer.png',
        Investment:process.env.VUE_APP_ROOT_ICONS_URL + 'Investment.png',
        Investment_active:process.env.VUE_APP_ROOT_ICONS_URL + 'Investment_active.png',
        Liabilities:process.env.VUE_APP_ROOT_ICONS_URL + 'Liabilities.png',
        Liabilities_active:process.env.VUE_APP_ROOT_ICONS_URL + 'ic_active_liabilities.png',
        userActive:process.env.VUE_APP_ROOT_ICONS_URL + 'useractive.png',
        userInactive:process.env.VUE_APP_ROOT_ICONS_URL + 'userinactive.png',
        Accounts: process.env.VUE_APP_ROOT_ICONS_URL + "Accounts.png",
        Accounts_active:process.env.VUE_APP_ROOT_ICONS_URL + "Account_active.png",
        Wills: process.env.VUE_APP_ROOT_ICONS_URL + "Wills.png",
        Wills_active: process.env.VUE_APP_ROOT_ICONS_URL + "Will_active.png",
        Subscription: process.env.VUE_APP_ROOT_ICONS_URL + "a_nps.png",
        Subscription_Active: process.env.VUE_APP_ROOT_ICONS_URL + "national_pension_scheme.png",
      }
    },
    methods:{
      checkUrl(val){
        return this.$route.meta.menu == val;
      }
    }
  }
</script>